import React from 'react';
// import JerseyWindSE from '../../../images/wind-icons/jersey-wind-south-east.svg';
import RainIconBlue from '../../../images/wind-icons/Rain-Icon-Blue.svg';
import RainIcon from '../../../images/wind-icons/Rain-Icon-Grey.svg';
import "./tabDetail.scss";
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from "gatsby"
const images = require.context('../../../images/wind-icons/', true);
const weatherImages = require.context('../../../images/weather-icons/', true);

const useStyles = makeStyles((theme) => {
  return {
  root: {
    minWidth: 275,
    width:"100%",
    textAlign:"left",
    height:"100%",
    fontFamily: "proxima-nova, sans-serif !important",
    padding:"0",
    boxShadow:"none",
    borderLeft: "1px solid #7d7d7d",
    borderRadius:0,
    paddingLeft:"12px",
    [theme.breakpoints.down('sm')]: {
      borderTop: "1px solid #7d7d7d",
      borderLeft: 0,
      paddingLeft:0,
      paddingTop:"12px",
    }
  },
  rootFirst: {
    minWidth: 275,
    width:"100%",
    textAlign:"left",
    height:"100%",
    fontFamily: "proxima-nova, sans-serif !important",
    padding:"0",
    boxShadow:"none",
    borderLeft: "0px",
    borderRadius:0,
    paddingLeft:0,
  },
  content: {
    padding:"0",
    
  },
  title: {
    fontSize: 14,
    fontWeight:"normal",
    marginLeft:"10px"
  },
  pos: {
    marginBottom: 12,
    fontSize:18,
  },
  iconGrid: {
    textAlign:"center",
  },
  focusStyle: {
    color:"#b60011",
    textDecoration:"inherit",
    "&:hover": {
    color:"#b60011",
    textDecoration:"underline",
    },
    "&:focus-visible": {
      color:"#b60011",
      }
  }
}
});

const TabDetail = (props) => {
  // const tabletVP = useMediaQuery('(max-width:1833px)');
  // const mobileVP = useMediaQuery('(max-width:1193px)');
  const classes = useStyles();
  if (props.today === true) {
    var timeRange = props.issuetime+" to 12:00";
  } else {
    var timeRange = "Sunrise at "+props.day.sunRise+" to 12:00";
  }
  var description = props.day.morningDescripiton;
  var rain =  props.day.rainProbMorning;
  var windDirection = props.day.windDirectionMorning;
  var windSpeed = props.day.windSpeedForceMorning;
  var windDescription = props.day.morningWindDescripiton
  var icon = props.day.iconMorning;
  var Temp = props.day.maxTemp;
  var TempType = "Max"
  var windToolTip ="";
  var dayToolTip=props.day.iconMorningToolTip;

  let fullWindDirectionDescription = props.day.windDirectionMorning
  if (props.mode ==="Afternoon") {fullWindDirectionDescription = props.day.windDirectionAfternoon}
  if (props.mode ==="Night") {fullWindDirectionDescription = props.day.windDirectionEvening}
  switch (fullWindDirectionDescription) {
    case "N": fullWindDirectionDescription = 'North'; break;
    case "NNE": fullWindDirectionDescription = 'North Northeast'; break;
    case "NE": fullWindDirectionDescription = 'Northeast'; break;
    case "ENE": fullWindDirectionDescription = 'East Northeast'; break;
    case "E": fullWindDirectionDescription = 'East'; break;
    case "ESE": fullWindDirectionDescription = 'East Southeast'; break;
    case "SE": fullWindDirectionDescription = 'Southeast'; break;
    case "SSE": fullWindDirectionDescription = 'South Southeast'; break;
    case "S": fullWindDirectionDescription = 'South'; break;
    case "SSW": fullWindDirectionDescription = 'South Southwest'; break;
    case "SW": fullWindDirectionDescription = 'Southwest'; break;
    case "WSW": fullWindDirectionDescription = 'West Southwest'; break;
    case "W": fullWindDirectionDescription = 'West'; break;
    case "WNW": fullWindDirectionDescription = 'West Northwest'; break;
    case "NW": fullWindDirectionDescription = 'Northwest'; break;
    case "NNW": fullWindDirectionDescription = 'North Northwest'; break;
    default: fullWindDirectionDescription = ''; break;
}
  windToolTip = `${windSpeed} ${fullWindDirectionDescription}`  
  if (props.windMode === "Miles") {
    windSpeed = props.day.windspeedMphMorning;
    windToolTip = `${windSpeed} mph ${fullWindDirectionDescription}`
  }

  if (props.windMode === "Kilometres") {
    windSpeed = props.day.windspeedKMMorning;
    windToolTip = `${windSpeed} km ${fullWindDirectionDescription}`
  }

  if (props.windMode === "Knots") {
    windSpeed = props.day.windspeedKnotsMorning;
    windToolTip = `${windSpeed} Knots ${fullWindDirectionDescription}`
  }

  if (props.tempMode !== "Celsius") {
    Temp = props.day.maxTempFahrenheit;
  }

  if (props.mode ==="Morning") {
    Temp = props.day.morningTemp;
    if (props.tempMode !== "Celsius") {
      Temp = props.day.morningTempFahrenheit;
    }
  }


  if (props.today) {
    TempType = "Current";
    Temp = props.currentTemp
    if (props.tempMode !== "Celsius") {
      Temp = props.currentTempF;
    }
  }
  if (props.today && props.title === 'Guernsey weather') {
    TempType = "Max";
    Temp = props.day.maxTemp;
    if (props.tempMode !== "Celsius") {
      Temp = props.day.maxTempF;
    }
  }

  if (props.mode ==="Afternoon") {
    // timeRange="12:00 to sunset "+props.day.sunSet;
    if (props.today === true && props.first) {
      timeRange= props.issuetime + " to sunset "+props.day.sunSet;
    } else {
      timeRange="12:00 to sunset "+props.day.sunSet;
    }
    description = props.day.afternoonDescripiton;
    rain =  props.day.rainProbAfternoon;
    windDirection = props.day.windDirectionAfternoon;
    windSpeed = props.day.windSpeedForceAfternoon;
    icon = props.day.iconAfternoon;
    windDescription = props.day.afternoonWindDescripiton
    dayToolTip=props.day.iconAfternoonToolTip;
    windToolTip = `${windSpeed} ${fullWindDirectionDescription}`
  
    TempType = "Max";
    Temp = props.day.maxTemp;
    if (props.tempMode !== "Celsius") {
      Temp = props.day.maxTempF;
    }

    if (props.windMode === "Miles") {
      windSpeed = props.day.windspeedMphAfternoon;
      windToolTip = `${windSpeed} mph ${fullWindDirectionDescription}`
    }

    if (props.windMode === "Kilometres") {
      windSpeed = props.day.windspeedKMAfternoon;
      windToolTip = `${windSpeed} km ${fullWindDirectionDescription}`
    }

    if (props.windMode === "Knots") {
      windSpeed = props.day.windspeedKnotsAfternoon;
      windToolTip = `${windSpeed} Knots ${fullWindDirectionDescription}`
    }
  }

  if (props.mode ==="Night") {
//    timeRange="Sunset "+props.day.sunSet+" to sunrise at " + props.day.sunRiseTomorrow;
    if (props.today === true && props.first === true) {
      timeRange= props.issuetime + " to sunrise "+props.day.sunRiseTomorrow;
    } else {
      timeRange="Sunset "+props.day.sunSet+" to sunrise at " + props.day.sunRiseTomorrow;
    }
    description = props.day.nightDescripiton;
    var frost = props.day.frost;
    rain =  props.day.rainProbEvening;
    windDirection = props.day.windDirectionEvening;
    windSpeed = props.day.windSpeedForceEvening;
    icon = props.day.iconEvening;
    Temp = props.day.minTemp;
    TempType = "Min"
    windDescription = props.day.nightWindDescripiton
    dayToolTip=props.day.iconEveningToolTip;
    windToolTip = `${windSpeed} ${fullWindDirectionDescription}`
    
    if (props.windMode === "Miles") {
      windSpeed = props.day.windspeedMphEvening;
      windToolTip = `${windSpeed} mph ${fullWindDirectionDescription}`
    }

    if (props.windMode === "Kilometres") {
      windSpeed = props.day.windspeedKMEvening;
      windToolTip = `${windSpeed} km ${fullWindDirectionDescription}`
    }

    if (props.windMode === "Knots") {
      windSpeed = props.day.windspeedKnotsEvening;
      windToolTip = `${windSpeed} Knots ${fullWindDirectionDescription}`
    }

    if (props.tempMode !== "Celsius") {
      Temp = props.day.minTempFahrenheit;
    }
  }

  let windIcon =  images('./blank.svg');
  if (typeof(props.day.windDirection) != "undefined")
    windIcon =  images('./'+windDirection+'.svg');

  let weatherIcon =  weatherImages('./blank.svg');
  if (typeof(props.day.dayIcon) !== "undefined" && props.day.dayIcon !== null)
    weatherIcon =  weatherImages('./'+icon);

  return (
    <Card className={props.first ? classes.rootFirst : classes.root}>
      <CardContent className={classes.content}>
        <h2 className="detailTitle">
          {props.mode}{props.title === 'Jersey weather' && <Link className={classes.focusStyle} to="/sunrisesunset"><span className="subTitle">{timeRange}</span></Link>}
          {props.title === 'Guernsey weather' && <Link className={classes.focusStyle} to="/sunrisesunset-guernsey"><span className="subTitle">{timeRange}</span></Link>}
        </h2>
        <br />
        <Grid container spacing={0} style={{alignItems: "center", justifyContent: "center"}}>
          <Grid className={classes.iconGrid} item xs={4} sm={3} md={3} lg={3}>
          <Tooltip title={dayToolTip} aria-label={dayToolTip}>
            <img className="weatherIcon" src={weatherIcon.default} alt={dayToolTip + " " + icon}/>
          </Tooltip>
          </Grid>
          <Grid className={classes.iconGrid} item xs={3} sm={3} md={3} lg={3}>
            {TempType}<br /><span className="boldWeather">{Temp}</span>
          </Grid>
          <Grid className={classes.iconGrid} item xs={2} sm={3} md={3} lg={3} >
            {rain}%<br />
            <Tooltip title="Rain" aria-label="Rain">
            { rain > 19 ? <img className="rainIcon" src={RainIconBlue} alt=""/> : <img className="rainIcon" src={RainIcon} alt=""/> }
            </Tooltip>
          </Grid>
          <Grid className={classes.iconGrid} item xs={3} sm={3} md={3} lg={3}>  
          <div className="windDetail">
            <img className="windIconDetail" src={windIcon.default} alt="" />            
            <Tooltip title={windToolTip} aria-label={windToolTip}>
            <div className="windSpeedDetail">{windSpeed}</div>
            </Tooltip>
          </div>      
          </Grid>
        </Grid>
        <p className="description">
          {description} {frost}<br />
          {windDescription}
        </p>
      </CardContent>
    </Card>  
  )
}
export default TabDetail
